import * as PIXI from 'pixi.js';
import { AnimatedGIF } from '@pixi/gif'; // Required for GIF support. Do not delete this line.
import { CheckUrlFromStorage, addToCache, getFromCache, getProxyUrl } from './Utils';

function Load(src, isDisplayElement, id) {
  var uniqueName = '';
  var url = '';
  if (src.url && src.url.startsWith('data:image')) {
    uniqueName = GetUniqueName(src);
    url = src.url;
  } else {
    if (src.url) {
      uniqueName = GetUniqueName(src);
      url = src.url;
    } else {
      uniqueName = src;
      url = src;
    }
    if (!CheckUrlFromStorage(url) && !isDisplayElement && !url.startsWith('blob:')) {
      url = getProxyUrl(url);
    } else {
      if (url.toLowerCase().startsWith('http')) {
        let parsedUrl = new URL(url);
        if (!isDisplayElement) {
          parsedUrl.searchParams.append('source', 'preview');
        }
        url = parsedUrl.toString();
      }
    }
  }
  if (isDisplayElement) {
    if (!getFromCache(id ? url + id : url)) {
      let parsedUrl = new URL(url);
      if (
        !CheckUrlFromStorage(url) &&
        !url.includes('cdn.jsdelivr.net') &&
        !url.includes('giphy.com') &&
        !url.startsWith('data:image') &&
        !url.includes('raw.githubusercontent.com') &&
        !url.startsWith('blob:')
      ) {
        var proxyUrl = getProxyUrl(url);
        parsedUrl = new URL(proxyUrl);
      }
      // if (id) {
      //   parsedUrl.searchParams.append('identifier', id);
      // }
      //parsedUrl.search ='';
      let visualUrl = parsedUrl.toString();
      PIXI.Assets.load(visualUrl)
        .then((value) => {
          if (id) {
            if (!value) {
              let tex = PIXI.Texture.from(visualUrl);
              tex?.baseTexture?.resource?.source?.pause?.();
              addToCache(url + id, tex.clone());
            } else {
              value?.baseTexture?.resource?.source?.pause?.();
              addToCache(url + id, value.clone());
            }
          } else {
            addToCache(url, value.clone());
          }
          // let ret = getFromCache(url);
          // console.log(ret);
          //PIXI.Assets.unload(url);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  } else if (!PIXI.utils.TextureCache[uniqueName]) {
    let texture = PIXI.Texture.from(url);
    texture.isLoadError = false;
    texture.baseTexture.onError = () => {
      let texturebase = PIXI.Texture.from(src.url ? src.url : src);
      texturebase.isLoadError = false;
      PIXI.Texture.removeFromCache(uniqueName);
      PIXI.Texture.addToCache(texturebase, uniqueName);
      texturebase.baseTexture.onError = () => {
        let errorTexture = new PIXI.Texture(new PIXI.BaseTexture());
        errorTexture.isLoadError = true;
        PIXI.Texture.removeFromCache(uniqueName);
        PIXI.Texture.addToCache(errorTexture, uniqueName);
      };
    };
    PIXI.Texture.removeFromCache(uniqueName);
    PIXI.Texture.addToCache(texture, uniqueName);
  }
}

function GetUniqueName(src) {
  if (src.asset_id) {
    return src.start ? src.asset_id + src.start : src.asset_id;
  } else {
    var name = src.start ? src.url + src.start : src.url;
    name = name + (src.resource_id ? src.resource_id : '');
    return name;
  }
}
function CheckIfImageTextureValid(src) {
  var Texture = PIXI.utils.TextureCache[GetUniqueName(src)];
  return Texture && Texture.valid ? true : false;
}
function GetTexture(src) {
  if (src.url) {
    return PIXI.utils.TextureCache[GetUniqueName(src)];
  } else {
    return PIXI.utils.TextureCache[src];
  }
}
function RemoveTexture(src) {
  var uniqueName = '';
  if (src.url) {
    uniqueName = GetUniqueName(src);
  } else {
    uniqueName = src;
  }
  PIXI.Texture.removeFromCache(uniqueName);
}
export default {
  Load,
  GetUniqueName,
  CheckIfImageTextureValid,
  GetTexture,
  RemoveTexture,
};
